import axios from "~/plugins/axios";

export default {
  breadcrumbs(attachableClass, attachableId) {
    return axios.post("/web_api/v1/attachable/breadcrumbs", {
      attachableClass,
      attachableId,
    }).then((response) => response.data);
  },
  find(attachableId, includes = []) {
    const uri = `/web_api/v1/attachable/${attachableId}`;
    return axios.get(uri, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  generateDownloadLink(attachableId) {
    const uri = `/web_api/v1/attachable/${attachableId}/generate-download-link`;
    return axios.post(uri).then((response) => response.data);
  },
  generateDownloadZipLink(attachableIds) {
    const uri = "/web_api/v1/attachable/generate-download-zip-link";
    return axios.post(uri, {
      ids: attachableIds,
    }).then((response) => response.data);
  },
  update(attachable, includes = []) {
    const uri = `/web_api/v1/attachable/${attachable.id}`;
    return axios.put(uri, attachable, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  move(attachableId, attachableCategoryId, includes = []) {
    const uri = `/web_api/v1/attachable/${attachableId}/move`;
    return axios.put(uri, {
      attachable_category_id: attachableCategoryId,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  copy(attachableId, attachableCategoryId, includes = []) {
    const uri = `/web_api/v1/attachable/${attachableId}/copy`;
    return axios.put(uri, {
      attachable_category_id: attachableCategoryId,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  moveAll(attachableIds, attachableCategoryId, includes = []) {
    const uri = "/web_api/v1/attachable/move";
    return axios.put(uri, {
      attachable_ids: attachableIds,
      attachable_category_id: attachableCategoryId,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  copyAll(attachableIds, attachableCategoryId, includes = []) {
    const uri = "/web_api/v1/attachable/copy";
    return axios.put(uri, {
      attachable_ids: attachableIds,
      attachable_category_id: attachableCategoryId,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  delete(attachableId, deleteLinkedInstance = true) {
    const uri = `/web_api/v1/attachable/${attachableId}`;
    return axios.delete(uri, {
      data: {
        delete_linked_instance: deleteLinkedInstance,
      },
    }).then((response) => response.data);
  },
  deleteAll(attachableIds, deleteLinkedInstance = true) {
    const uri = "/web_api/v1/attachable/delete";
    return axios.delete(uri, {
      data: {
        attachable_ids: attachableIds,
        delete_linked_instance: deleteLinkedInstance,
      },
    }).then((response) => response.data);
  },

  getByAttachableCategoryId(attachableCategoryId, page, perPage, orderBy, order, includes = []) {
    const uri = `/web_api/v1/attachable/by_attachable_category/${attachableCategoryId}`;
    return axios.get(uri, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getByCustomerIdAndCategory(
    customerId, category, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = "/web_api/v1/attachable/by_customer_and_category";
    return axios.post(uri, {
      customer_id: customerId,
      category,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  paginateByCustomerIdCategoryAndChildClass(
    customerId, category, childClass, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = "/web_api/v1/attachable/by_customer_category_and_child_class";
    return axios.post(uri, {
      customer_id: customerId,
      category,
      child_class: childClass,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  paginateByFamilyCategoryAndChildClass(
    customerId, category, childClass, page, perPage, orderBy, order, includes = [], filter,
  ) {
    const uri = "/web_api/v1/attachable/by_family_category_and_child_class";
    return axios.post(uri, {
      customer_id: customerId,
      category,
      child_class: childClass,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  paginateByInstanceAndChildClass(
    instance, childClass, page, perPage, orderBy, order, includes = [], filter = [],
  ) {
    return axios.post("/web_api/v1/attachable/by_instance_and_child_class", {
      instance,
      child_class: childClass,
      filter,
    }, {
      params: {
        page,
        perPage,
        orderBy,
        order,
        include: includes,
      },
    }).then((response) => response.data);
  },
  countByCustomerIdCategoryAndChildClass(
    customerId, category, childClass,
  ) {
    const uri = "/web_api/v1/attachable/count_by_customer_category_and_child_class";
    return axios.post(uri, {
      customer_id: customerId,
      category,
      child_class: childClass,
    }).then((response) => response.data);
  },
  countByCustomerAndCategory(customerId, category) {
    const uri = "/web_api/v1/attachable/count_by_customer_and_category";
    return axios.post(uri, {
      customer_id: customerId,
      category,
    }).then((response) => response.data);
  },
  countForFamilyByCustomerAndCategory(customerId, category) {
    const uri = "/web_api/v1/attachable/count_for_family_by_customer_and_category";
    return axios.post(uri, {
      customer_id: customerId,
      category,
    }).then((response) => response.data);
  },
  countByFamilyCategoryAndChildClass(
    customerId, category, childClass,
  ) {
    const uri = "/web_api/v1/attachable/count_by_family_category_and_child_class";
    return axios.post(uri, {
      customer_id: customerId,
      category,
      child_class: childClass,
    }).then((response) => response.data);
  },
  countByInstanceAndChildClass(
    instance,
    childClass,
  ) {
    return axios.post("/web_api/v1/attachable/count_by_instance_and_child_class", {
      instance,
      child_class: childClass,
    }).then((response) => response.data);
  },
  getByClass(
    instanceClass,
    instanceId,
    includes = [],
  ) {
    return axios.post("/web_api/v1/attachable/by_class", {
      has_attachable_class: instanceClass,
      has_attachable_id: instanceId,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  getByHasAttachableAndIsAttachableType(
    hasAttachableType,
    hasAttachableId,
    isAttachableType,
    includes = [],
  ) {
    return axios.post("/web_api/v1/attachable/by_has_attachable_and_is_attachable_type", {
      has_attachable_type: hasAttachableType,
      has_attachable_id: hasAttachableId,
      is_attachable_type: isAttachableType,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  byHasAttachable(hasAttachableType, hasAttachableId) {
    return axios.post("/web_api/v1/attachable/by_has_attachable", {
      has_attachable_id: hasAttachableId,
      has_attachable_type: hasAttachableType,
    }).then((response) => response.data);
  },
};
